import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "button", "input"]
  
  connect() {
    // Initially hide the form
    this.formTarget.style.display = "none"
  }
  
  toggle() {
    if (this.formTarget.style.display === "none") {
      this.show()
    } else {
      this.hide()
    }
  }
  
  show() {
    // Hide the button and show the form
    this.buttonTarget.style.display = "none"
    this.formTarget.style.display = "block"
    
    // Focus on the input field
    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }
  
  hide() {
    // Show the button and hide the form
    this.buttonTarget.style.display = "block"
    this.formTarget.style.display = "none"
    
    // Clear the input
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
  }
  
  cancel() {
    this.hide()
  }
  
  // Handle escape key to cancel
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hide()
    }
  }
  
  // Handle clicking outside to cancel
  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}